// import React from "react";
// import { Routes, Route } from "react-router-dom";
// import { useSelector } from "react-redux"; // Import useSelector here

// // Layouts
// import NonAuthLayout from "../Layouts/NonAuthLayout";
// import Layout from "../Layouts";

// // Routes
// import { publicRoutes, authProtectedRoutes } from "./allRoutes";

// import { AuthProtected } from "./AuthProtected";
// import { useState, useEffect } from "react";

// const Index = () => {
//   const userRole = useSelector((state) => state.authorise.userRole);
//   const [isLoggedIn, setIsLoggedIn] = useState(!!userRole);

//   useEffect(() => {
//     setIsLoggedIn(!!userRole);
//   }, [userRole, isLoggedIn]);

//   return (
//     <React.Fragment>
//       <Routes>
//         <Route>
//           {publicRoutes.map((route, idx) => (
//             <Route
//               path={route.path}
//               element={<NonAuthLayout>{route.component}</NonAuthLayout>}
//               key={idx}
//               exact={true}
//             />
//           ))}
//         </Route>

//         <Route>
//           {authProtectedRoutes
//             .filter((route) => {
//               if (!route.roles) {
//                 return true;
//               }
//               return route.roles.includes(userRole);
//             })
//             .map((route, idx) => (
//               <Route
//                 path={route.path}
//                 element={
//                   <AuthProtected>
//                     <Layout>{route.component}</Layout>
//                   </AuthProtected>
//                 }
//                 key={idx}
//                 exact={true}
//               />
//             ))}
//         </Route>
//       </Routes>
//     </React.Fragment>
//   );
// };

// export default Index;
import React from "react";
import { Routes, Route } from "react-router-dom";

// Layouts
import NonAuthLayout from "../Layouts/NonAuthLayout";
import Layout from "../Layouts";

// Routes
import { publicRoutes, authProtectedRoutes } from "./PublicRoutes";

import { AuthProtected } from "./AuthProtected";

const Index = () => {
  // Hardcoded role for simplicity
  const allowedRole = "IT_RECRUITER"; // Replace with the role you want to check
  // console.log(localStorage.getItem("role"));

  return (
    <React.Fragment>
      <Routes>
        {/* Public Routes */}
        <Route>
          {publicRoutes.map((route, idx) => (
            <Route
              path={route.path}
              element={<NonAuthLayout>{route.component}</NonAuthLayout>}
              key={idx}
              exact={true}
            />
          ))}
        </Route>

        {/* Auth Protected Routes */}
        <Route>
          {authProtectedRoutes
            .filter(() => allowedRole === "IT_RECRUITER") // Adjust this condition for other roles
            .map((route, idx) => (
              <Route
                path={route.path}
                element={
                  <AuthProtected>
                    <Layout>{route.component}</Layout>
                  </AuthProtected>
                }
                key={idx}
                exact={true}
              />
            ))}
        </Route>
      </Routes>
    </React.Fragment>
  );
};

export default Index;
